  // Cruise page scroll handler - unified solution for both ocean and river cruises
  (function() {
    // Immediately log page info to catch early execution
    console.log('Cruise-scroll-handler loaded - URL params:', window.location.search);
    
    document.addEventListener('DOMContentLoaded', function() {
      // Log environment details
      const currentPath = window.location.pathname;
      const templateSuffix = '{{ template.suffix }}';
      const productHandle = '{{ product.handle }}';
      const urlParams = new URLSearchParams(window.location.search);
      
      // Determine page type
      const isRiverCruisePage = 
        currentPath.includes('/products/custom-river-cruise-album-map') || 
        templateSuffix === 'river-cruise-album-bundle-product';
        
      const isOceanCruisePage = 
        currentPath.includes('/products/custom-cruise-album-map') ||
        currentPath.includes('/products/cruise-maps') || 
        templateSuffix === 'album-bundle-product';
      
      // Get scroll parameters
      const fromParam = urlParams.get('from');
      const shouldScrollParam = urlParams.get('scroll') === 'true';
      const shouldScroll = localStorage.getItem('scrollToMainProduct') === 'true' || shouldScrollParam;
      
      
      // Determine if we need to scroll:
      // 1. If we're on ocean cruise page and coming from river cruise
      // 2. If we're on river cruise page and coming from ocean cruise
      if ((isOceanCruisePage && (fromParam === 'river-cruise' || localStorage.getItem('scrollSource') === 'riverCruise') && shouldScroll) ||
          (isRiverCruisePage && (fromParam === 'ocean-cruise' || localStorage.getItem('scrollSource') === 'oceanCruise') && shouldScroll)) {
        
        // Clear localStorage flags right away to prevent issues with repeated scrolling
        localStorage.removeItem('scrollToMainProduct');
        localStorage.removeItem('scrollSource');
        localStorage.removeItem('scrollTimestamp');
        
        // Function to scroll to an element with proper offset for header
        function scrollToElement(element, message) {
          if (!element) {
            console.error('Cannot scroll to null element');
            return false;
          }
          
          const offset = 80; // Offset to account for header
          const elementPosition = element.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - offset;
          
          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
          
          return true;
        }
        
        // Use a timeout to ensure page is fully loaded
        setTimeout(function() {
          let scrollTarget = null;
          
          // Method 1: Try to find Step 1 heading by text content
          const headings = Array.from(document.querySelectorAll('h4, .h4, span.inline-richtext'));
          
          for (const heading of headings) {
            if (heading.textContent.includes('Step 1')) {
              scrollTarget = heading;
              break;
            }
          }
          
          // Method 2: Try to find by class in icon-with-text component
          if (!scrollTarget) {
            const iconWithTextItem = document.querySelector('.icon-with-text__item');
            if (iconWithTextItem) {
              scrollTarget = iconWithTextItem;
            }
          }
          
          // Method 3: Try to find the main product section
          if (!scrollTarget) {
            const mainProductSections = document.querySelectorAll('section[id^="MainProduct-"]');
            
            if (mainProductSections.length > 0) {
              scrollTarget = mainProductSections[0];
            }
          }
          
          // Method 4: Try to find the product form
          if (!scrollTarget) {
            const productForm = document.querySelector('form[id^="product-form-"]');
            if (productForm) {
              scrollTarget = productForm;
            }
          }
          
          // Attempt to scroll if we found a target
          if (scrollTarget) {
            scrollToElement(scrollTarget, 'Scrolling to:');
          } else {
            console.error('Could not find any suitable element to scroll to');
            
            // Last desperate attempt - try to scroll to a known distance
            window.scrollTo({
              top: 500, // Scroll down 500px as a fallback
              behavior: 'smooth'
            });
          }
        }, 1500); // Wait 1.5 seconds for page to fully load before scrolling
      }
    });
  })();